import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalBox from "../../ui/ModalBox";
import FormExpenses from "./FormExpenses";
import { Typography } from "@mui/material";

const AddExpenses = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };

  const handleSuccess = () => {
    setOpen(true);
  };
  return <div>

    <Typography variant="Poster" component="h4" gutterBottom
    >
      Add New Expense
    </Typography>
    <FormExpenses handleSuccess={handleSuccess} />
    <ModalBox
      open={open}
      handleClose={handleClose}
      text="The add operation has been completed successfully.. You added new expense"
      name="expense"
    />
  </div>;
};

export default AddExpenses;
